import Vue from 'vue'
import Axios from 'axios'
import Cookies from 'js-cookie'
import axiosWatcher from './axios-watcher'
import { tokenKey, getTarget, parseDynamicUrl, qs } from '@/utils/helper'

// 路径前缀
const baseURL = process.env.VUE_APP_SERVER
// axios base config
const baseConfig = {
    baseURL,
    // timeout: 2000,``
    headers: {
        // 'Content-Type': 'application/json; charset=utf-8',
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
}

// AOP
function intercept(instance) {
    // 请求前
    instance.interceptors.request.use(config => {
        // url动态参数转换 match :xx
        var params = Vue.$config.axios.route && Vue.$config.axios.route.params || {}
        config.url = parseDynamicUrl(config.url, params)

        // 令牌认证
        if (process.env.VUE_APP_IDENTITY_AUTH == "token" && !config.url.includes('/api/auth/jwt/token')) {
            config.headers['Authorization'] = Cookies.get(tokenKey())
            config.headers["target"] = getTarget()
        }

        // formUrl编码
        var contentType = config.headers['Content-Type']

        if (contentType && contentType.indexOf('x-www-form-urlencoded') >= 0) {
            if (config.data) {
                config.data = qs.stringify(config.data)
            }
        }

        // 开始观测
        axiosWatcher.requestStart(config)

        // log
        // console.log(config.method + " " + baseConfig.baseURL + config.url + '[' + config._seed + ']')

        return config
    }, error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    })

    // 请求后
    instance.interceptors.response.use(res => {
        console.log(`${res.config.url}:`,res)
        let { data, config } = res

        // Blob表示类文件对象
        if (!(data instanceof Blob)) {
            if (typeof data.data == "undefined") {
                data.data = {}
            }

            // 业务错误提示
            if (data.code !== 200) {
                // 结束观测
                axiosWatcher.requestDone(res)
                return Promise.reject(data)
            }
        }

        // 结束观测
        axiosWatcher.requestDone(res)

        return data
    }, error => {
        // 结束观测
        axiosWatcher.requestDone(error.response)
        
        return Promise.reject(error)
    })

    return instance
}

// prototype
var axios = Axios.create(baseConfig)
intercept(axios)

// extendable
axios.create = function(conf) {
    return intercept(Axios.create(Object.assign(baseConfig, conf)))
}

export default axios
